import { IRNG } from './rng';
import { DotValue } from './types';

export type TutorialScreen = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;

export const TUTORIAL_SCREENS = 14;

export const requiredColumns: Partial<Record<TutorialScreen, Set<number>>> = {
  3: new Set<number>([3]),
  5: new Set<number>([0]),
  9: new Set<number>([4]),
  10: new Set<number>([4]),
  12: new Set<number>([6]),
} as const;

export const highlightSolids: Partial<Record<TutorialScreen, boolean>> = {
  7: true,
  8: true,
} as const;

export type TutorialRNGState = DotValue[];

export class TutorialRNG implements IRNG<DotValue, TutorialRNGState> {
  protected values: DotValue[];

  constructor() {
    this.values = [5, 2, 4, 2, 3];
  }

  next() {
    return this.values.length > 0 ? this.values.shift()! : 1;
  }

  serialize(): TutorialRNGState {
    return [...this.values];
  }

  static deserialize(state: TutorialRNGState) {
    const rng = new TutorialRNG();
    rng.values = [...state];
    return rng;
  }

  clone() {
    return TutorialRNG.deserialize(this.serialize());
  }
}
